<template>
  <v-layout
    v-if="!$apollo.loading"
    wrap
  >
    <v-flex>
      <v-card
        v-if="step == 1 && (invoice != undefined && invoice != null)"
        class="wallet-card"
      >
        <v-flex
          v-if="attention"
          pb-5
        >
          <center>
            <b>{{ $t('wallets.attention') }}</b>
            {{ $t('wallets.payFromWarning') }}
            <br>
            <br>
            {{ $t('wallets.iWill') }}:
            <br>
            <b>{{ getUser.staking_wallet.wallet_address }}</b>
            <v-divider style="margin:20px 0 20px;" />
            <v-btn
              class="primary"
              @click="attention = false"
            >
              {{ $t('wallets.confirm') }}
            </v-btn>
          </center>
        </v-flex>
        <v-flex
          v-if="!attention"
          pb-5
        >
          <center>
            <v-btn
              v-if="startOverButton"
              style="margin-top:10px;"
              small
              text
              outlined
              @click="startOver()"
            >
              {{ $t('wallets.startOverButton') }}
            </v-btn>
            <div v-if="!waitingMetamaskResponse">
              <h4>{{ $t('gateway.walletPleaseSend1') }}</h4>
              <h3>{{ invoice.total }} {{ invoice.currency }}</h3>

              <p>
                {{ $t('wallets.from') }}
                <b>{{ obfuscatedWallet }}</b>
                {{ $t('gateway.walletPleaseSend2') }}
              </p>
              <b>{{ $t('gateway.copyWallet') }}</b>
              <v-text-field
                v-model="invoice.gateway_wallet"
                name="gateway-wallet"
                class="centered-input"
                readonly
                @focus="$event.target.select()"
              >
                <template v-slot:append>
                  <v-icon
                    v-clipboard:copy="invoice.gateway_wallet"
                    style="cursor:pointer;"
                  >
                    mdi-content-copy
                  </v-icon>
                </template>
              </v-text-field>
              <p>{{ $t('gateway.scanQrCode') }}</p>
              <qrcode
                :value="invoice.gateway_wallet"
                :options="{ width: 150 }"
              />
              <p>{{ $t('gateway.useMetamask') }}</p>
              <v-tooltip
                top
                :disabled="metamaskInstalled"
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-btn
                      style="margin-top: 10px;"
                      :disabled="!metamaskInstalled"
                      class="primary"
                      @click="sendViaMetamask()"
                    >
                      {{ $t('gateway.payViaMetamask') }}
                    </v-btn>
                  </div>
                </template>
                <span>{{ $t('wallets.metamaskNotInstalled') }}</span>
              </v-tooltip>
            </div>
            <div style="margin-top:15px;">
              <countdown
                :time="countDownTime"
                :transform="transform"
                @end="handleCountDownEnd"
              >
                <template slot-scope="props">
                  <small>
                    {{ $t('gateway.timeRemaining') }}:
                    <b>{{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}</b>
                  </small>
                </template>
              </countdown>
            </div>
            <div
              v-if="waitingMetamaskResponse"
              style="margin:20px 0 20px;"
            >
              {{ $t('wallets.pleaseWait') }}
              <v-progress-linear
                color="deep-purple accent-4"
                indeterminate
                rounded
                height="3"
              />
            </div>
          </center>
        </v-flex>
      </v-card>
      <v-card
        v-if="step == 2"
        class="wallet-card"
      >
        <v-flex
          pt-10
          pb-10
        >
          <center>
            <v-icon class="check-mark">
              mdi-checkbox-marked-circle-outline
            </v-icon>
            <h3>{{ $t('wallets.thankYou') }}</h3>
            {{ $t('gateway.metaMaskTransactionSent') }}
          </center>
        </v-flex>
      </v-card>
     
      <verify-steps
        v-if="step == 3"
        @onVerified="onVerified"
      />
    </v-flex>
  </v-layout>
  <v-layout v-else>
    <v-flex
      text-center
      mb-10
    >
      <v-progress-circular
        :size="40"
        color="primary"
        class="mb-2"
        indeterminate
      /><br>
      <b>{{ $t('packs.almostDone') }}</b>
    </v-flex>
  </v-layout>
</template>

<script>
import Metamask from "@/utils/metamask";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import VueCountdown from "@chenfengyuan/vue-countdown";
import VerifySteps from "@/views/Wallets/partial/VerifySteps.vue"

const INVOICE_QUERY = require("@/graphql/queries/Invoice.gql");
const GATEWAY_TOKEN_INFO_QUERY = require("@/graphql/queries/PaymentGatewayTokenInfo.gql");
const START_CRYPTO_PAYMENT_MUTATION = require("@/graphql/mutations/StartCryptoPayment.gql");

import { mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "AiviaGateway",
  components: {
    qrcode: VueQrcode,
    countdown: VueCountdown,
    VerifySteps
  },
  props: {
    invoice: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      step: true,
      attention: true,
      copied: false,
      metamask: null,
      startOverButton: false,
      metamaskInstalled: false,
      waitingMetamaskResponse: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    countDownTime() {
      let utc = this.$moment().add(-this.$moment().utcOffset(), 'm').utc();
      let started = this.$moment(this.invoice.crypto_payment_started_at)
      let time =
        60 * 30 * 1000  -
        Math.abs(utc.diff(started, 'seconds'));
      return time > 0 ? time : 0;
    },
    walletError() {
      const errors = [];
      if (!this.$v.stakingWallet.$dirty) return errors;
      !this.$v.stakingWallet.required &&
        errors.push(this.$t("wallets.reqWallet"));
      !this.$v.stakingWallet.validate_wallet &&
        errors.push(this.$t("wallets.ethWalletNotValid"));
      return errors;
    },
    obfuscatedWallet() {
      const wallet = this.getUser.staking_wallet.wallet_address;
      return (
        wallet.substring(0, 4) +
        "..." +
        wallet.substring(wallet.length - 5, wallet.length - 1)
      );
    }
  },
  mounted() {
    this.metamask = new Metamask();
    this.metamaskInstalled = this.metamask.isInstalled();
  },
  methods: {
    onVerified() {
      this.step = 1
    },
    onCopy() {
      this.copied = true;
    },
    handleCountDownEnd() {},
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value;
        props[key] = `${digits}`;
      });
      return props;
    },
    async sendViaMetamask() {
      if (this.metamask.getProvider() != "ethereum") {
        store.commit("app/setNotifier", this.$t("proile.metaMaskVersion"));
        return;
      }

      try {
        let enabled = await ethereum.enable();
      } catch (error) {
        store.commit("app/setNotifier", this.$t("wallets.metaMaskAccept"));
      }
      let account = await this.metamask.getAccount();
      let balance = (await this.metamask.getBalance(account)) / 10 ** 18;
      let gasPrice = await this.metamask.getGasPrice();

      if (
        account.toLowerCase() !=
        this.getUser.staking_wallet.wallet_address.toLowerCase()
      ) {
        store.commit(
          "app/setNotifier",
          this.$t("gateway.metaMaskaddressNotMatched")
        );
        return;
      }

      let data = {
        from: this.getUser.staking_wallet.wallet_address,
        to: this.invoice.gateway_wallet,
        contractAddress: this.paymentGatewayTokenInfo.contract_address,
        abi: JSON.parse(this.paymentGatewayTokenInfo.contract_abi),
        gasPrice: gasPrice,
        gasLimit: 100000,
        value: this.invoice.total * 10 ** this.paymentGatewayTokenInfo.exponent
      };

      let contract = this.metamask.getContract(data);
      let tokenBalance = 0;

      tokenBalance = await contract.methods
        .balances(data.from)
        .call({ from: data.from });

      if (tokenBalance < data.value) {
        store.commit(
          "app/setNotifier",
          this.$t("gateway.metaMaskNotEnoughUsdtAmount")
        );
        return;
      }

      let receipt = null;

      this.waitingMetamaskResponse = true;
      receipt = await contract.methods
        .transfer(data.to, data.value)
        .send({ from: data.from })
        .on("confirmation", (confirmationNumber, receipt) => {})
        .on("receipt", receipt => {
          if (receipt != null) this.step = 2;
        })
        .on("error", error => {
          error = this.$t("wallets.metaMaskTransactionDeclined");
          this.waitingMetamaskResponse = false;
          store.commit("app/setNotifier", error);
        });
    }
  },
  
  apollo: {
    invoice: {
      query: INVOICE_QUERY,
      variables() {
        return {
          id: this.invoice.id
        };
      },
      result(data) {
        if (data.loading == false) {
          if (this.getUser.staking_wallet == null) {
            this.step = 3;
            return;
          }
          let invoice = data.data.invoice;
          if (invoice != null) {
            if (invoice.status == "paid") {
              return;
            }
            if (
              invoice.status == "unpaid" &&
              invoice.crypto_payment_started_at == null
            ) {
              this.loading = true;
              this.$apollo
                .mutate({
                  mutation: START_CRYPTO_PAYMENT_MUTATION,
                  variables: {
                    invoice_id: invoice.id
                  }
                })
                .then(data => {
                  this.$apollo.queries.invoice.refetch();
                })
                .catch(error => {
                  this.errorHandler(error);
                  this.loading = false;
                });
              return;
            }
          }
        }
      }
    },
    paymentGatewayTokenInfo: {
      query: GATEWAY_TOKEN_INFO_QUERY,
      variables() {
        return {
          name: this.invoice.currency.toLowerCase()
        };
      }
    },
  }
};
</script>
<style lang="scss" >
.wallet-card {
  padding: 10px 20px !important;
  h3 {
    margin: 5px;
  }
  h4 {
    margin: 15px 0 0;
    font-weight: 600 !important;
  }
  center {
    margin-top: 10px;
  }
  .v-card__title {
    margin-bottom: 30px !important;
  }
  p {
    margin: 0;
  }
  .centered-input {
    input {
      text-align: center !important;
    }
  }
  .v-image {
    margin: 15px 0 10px;
  }
  .check-mark {
    color: #75b211;
    font-size: 54px;
  }
}
</style>
